import * as THREE from "three";
import type CameraControls from "camera-controls";





type FitOptions = {
    paddingTop: number;
    paddingBottom: number;
    paddingLeft: number;
    paddingRight: number;
    productHeight?: number;
    productCenter?: THREE.Vector3;
};


type ThreeViewer = {
	targetObjectNames: any
    controls: CameraControls;
    scene: THREE.Scene;
    product: THREE.Object3D;
    center: THREE.Vector3;
    isMobile?: boolean;
    fitToSection?: boolean;
};

declare global {
    interface Window {
        threeViewer: ThreeViewer;
    }
}

// Reusable vectors
const v1 = new THREE.Vector3(0, 0, 1);
//const centerVector = new THREE.Vector3(0, 0, 0);

export default async function animateTo(angleSection: number, durationTime: number): Promise<boolean | void> {
    return new Promise<boolean | void>(async (resolve) => {



        const threeViewer = window.threeViewer as ThreeViewer;
        let { controls, product, center } = threeViewer;



        //const isAnimation = true
        const duration = durationTime || 0.25;


        v1.applyAxisAngle(new THREE.Vector3(0, 1, 0), angleSection);
        //const cameraPos = center.clone().add(v1);

        /*const rad = THREE.MathUtils.degToRad(angleSection);
        const dir = new THREE.Vector3(0, 0, 1).applyAxisAngle(new THREE.Vector3(0, 1, 0), rad);
        const cameraPos = center.clone().add(dir);*/



        //const target = controls.getTarget(new THREE.Vector3()).clone();

        const options: FitOptions = {
            paddingTop: 0.03,
            paddingBottom: 0.03,
            paddingLeft: 0.03,
            paddingRight: 0.03
        };

        const fitObject: any = product;


        (controls as any).smoothTime =duration / 2;

        //controls.setLookAt(cameraPos.x, cameraPos.y, cameraPos.z, 0, target.y, 0, isAnimation);



        (controls as any).smoothTime = duration / 1.5;

        let box = new THREE.Box3().setFromObject(product);
        let maxWidth = Math.max(box.max.x, box.max.z, Math.abs(box.min.x), Math.abs(box.min.z));
        box.max.x = box.max.z = maxWidth;
        box.min.x = box.min.z = -maxWidth;

        if (fitObject === product) {
            let productBox = new THREE.Box3().setFromObject(product);
            options.productHeight = productBox.max.y - productBox.min.y;
            options.productCenter = productBox.getCenter(new THREE.Vector3());
        }



        fitToRect(fitObject, maxWidth, options, angleSection).then(() => {

            resolve(true);
        });
    });
}

const _centerPosition = new THREE.Vector3();
const _normal = new THREE.Vector3();
const _cameraPosition = new THREE.Vector3();

function fitToRect(
    rect: any,
    inMaxWidth: number,
    options: FitOptions,
    angleSection: number

): Promise<void> {
    return new Promise<void>((resolve) => {
        const rectDim = {
            width: Math.max(rect.size?.x ?? 0, inMaxWidth),
            height: options.productHeight ?? rect.size?.y ?? 0,
            center: _centerPosition.copy(rect.point ?? new THREE.Vector3())
        };

        const controls = window.threeViewer.controls;

        rect.updateMatrixWorld?.();
        rectDim.center.y = options.productCenter ? options.productCenter.y : rectDim.center.y;


        const angleInRadians = THREE.MathUtils.degToRad(angleSection);
        const quaternion = new THREE.Quaternion().setFromAxisAngle(
            new THREE.Vector3(0, 1, 0),
            angleInRadians
        );




        //const quaternion = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), rect.userData?.radialAngle ?? 0);
        const rectNormal = _normal.set(0, 0, 1).applyQuaternion(quaternion);

        addPadding(rectDim, options);

        rectNormal.multiplyScalar(-1);
        const distance = (controls as any).getDistanceToFitBox(rectDim.width, rectDim.height, 0) as number;
        const cameraPosition = _cameraPosition.copy(rectNormal).multiplyScalar(-distance).add(rectDim.center);

        controls
        .setLookAt(
            cameraPosition.x,
            cameraPosition.y,
            cameraPosition.z,
            0,
            rectDim.center.y,
            0,
            true
        )
        .then(() => {
            delay100ms(300).then(() => resolve());
        });
    });
}

function delay100ms(time: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, time));
}

function addPadding(
    rectDim: { width: number; height: number; center: THREE.Vector3 },
    padding: FitOptions
): void {
    rectDim.height += padding.paddingTop;
    rectDim.center.y += padding.paddingTop / 2;

    rectDim.width += padding.paddingLeft;
    rectDim.center.x -= padding.paddingLeft / 2;

    rectDim.width += padding.paddingRight;
    rectDim.center.x += padding.paddingRight / 2;

    rectDim.height += padding.paddingBottom;
    rectDim.center.y -= padding.paddingBottom / 2;
}